import Icon from 'vue-awesome/components/Icon'

Icon.register({
  edit_location: {
    paths: [
      {
        d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7a.38.38 0 01.54 0l.9.9c.15.15.15.39 0 .54z'
      }
    ],
    width: '24',
    height: '24'
  }
})
